import PubSub from 'pubsub-js';

export const CODE_RECEIVED = 'code_received';

export const NUMBER_RECEIVED = 'number_received';

export const STORE_EVENT = 'store_event';

export const ERROR_MESSAGE = 'error_event';

export default PubSub;
